import { Grid } from 'components/box';
import {
  CustomizableOptionInterface,
  CustomizableOptionValueInterface,
  CustomizableOptionValuesInterface,
} from 'types/types';
import SizePillOption from './size-pill-option';

const SMALL_PILL_MAX_LABEL_LENGTH = 5;

const SMALL_PILL_MIN_STRETCH_COUNT = 5;
const LARGE_PILL_MIN_STRETCH_COUNT = 3;

const SMALL_PILL_WIDTH = 61;
const MEDIUM_PILL_WIDTH = 80;
const LARGE_PILL_WIDTH = 90;

const LARGE_PILL_MAX_COUNT_FOR_MEDIUM_WIDTH = 4;

const SizePill = ({
  option,
  selectedValueId,
  isHighlighted,
  select,
}: {
  option: CustomizableOptionValuesInterface;
  selectedValueId?: string;
  isHighlighted?: boolean;
  select: (
    option: CustomizableOptionInterface,
    value?: CustomizableOptionValueInterface
  ) => void;
}) => {
  const pillCount = option.values.length;

  const maxLabelLength = pillCount
    ? Math.max(...option.values.map(value => value.label.length))
    : 0;

  const isSmallPill = maxLabelLength <= SMALL_PILL_MAX_LABEL_LENGTH;

  const shouldStretch =
    (isSmallPill && pillCount >= SMALL_PILL_MIN_STRETCH_COUNT) ||
    (!isSmallPill && pillCount >= LARGE_PILL_MIN_STRETCH_COUNT);

  const pillWidth = isSmallPill
    ? SMALL_PILL_WIDTH
    : pillCount >= LARGE_PILL_MAX_COUNT_FOR_MEDIUM_WIDTH
    ? MEDIUM_PILL_WIDTH
    : LARGE_PILL_WIDTH;

  const gridTemplateColumns = shouldStretch
    ? `repeat(auto-fill, minmax(${pillWidth}px, 1fr))`
    : `repeat(${pillCount}, minmax(${pillWidth}px, 1fr))`;

  return (
    <Grid
      role="radiogroup"
      aria-label={option.label}
      gridTemplateColumns={gridTemplateColumns}
      gridRowGap={1}
      gridColumnGap={1}
    >
      {option.values.map(value => (
        <SizePillOption
          key={value.id}
          option={option}
          value={value}
          isSelected={selectedValueId === value.id}
          isHighlighted={isHighlighted}
          onSelect={select}
        />
      ))}
    </Grid>
  );
};

export default SizePill;
